import { querySelectorAll } from '../helpers'

export function initializeRelevantPages(selector: string) {
  querySelectorAll(selector).forEach((el: Element) => {
    const select = el.querySelector('select')
    if (select) {
      const groups: HTMLElement[] = querySelectorAll(
        '.relevant-pages_group',
        el
      )

      const selectGroup = (groupId: string) => {
        groups.forEach(group => {
          group.classList.toggle(
            'relevant-pages_group--active',
            group.dataset.groupId === groupId
          )
        })
      }

      select.addEventListener('change', () => {
        selectGroup(select.selectedOptions[0].value)
      })
    }
  })
}
